import { IconsEnum } from "../../enums/icon.enum";

export const footer = [
    {name: 'Home', route: '/', icon: IconsEnum.HOME},
    {name: 'My Car', route: '/my-car', icon: IconsEnum.SEARCH},
    {name: "FAQ's", route: '/faqs', icon: IconsEnum.FILLED_QUESTION},
    {name: "Terms and Conditions", route: "https://cdn.sanity.io/files/ofroafvk/production/260db9fc776017661ba5af6aace2d4deae4079dc.pdf", icon: IconsEnum.DOCUMENT},
    {name: 'About iLease', route: '/about-ilease', icon: IconsEnum.INFO},
    {name: "Sample Documents", route: '/sample-documents', icon: IconsEnum.DOCUMENT},
]